export default function EduTestingAppsInfo() {
  return (
    <div style={{ color: "#475467", lineHeight: 1.6 }}>
      Edit the global EDU Testing Hub catalog. EDU organization admins can enable or hide these apps, but they cannot change the shared launch URLs.
    </div>
  );
}
